import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import PoVarianceDocument from 'src/sections/variance_details/PoVarianceDocument';
import VarianceActionButtons from 'src/sections/variance_details/VarianceActionButtons';
import VarianceDetailsContextProvider from 'src/sections/variance_details/VarianceDetailsContext';
import VarianceDetailsInfo from 'src/sections/variance_details/VarianceDetailsInfo';
import VarianceGlCode from 'src/sections/variance_details/VarianceGlCode';
import VarianceGlPeriod from 'src/sections/variance_details/VarianceGlPeriod';
import VarianceLineItem from 'src/sections/variance_details/VarianceLineItem';

const VarianceDetails = () => (
  <VarianceDetailsContextProvider>
    <Navbar title="Variance Details" />
    <VarianceActionButtons />
    <Layout>
      <VarianceDetailsInfo />
      <PoVarianceDocument />
      <VarianceGlPeriod />
      <VarianceGlCode />
      <VarianceLineItem />
    </Layout>
  </VarianceDetailsContextProvider>
);

export default VarianceDetails;
